/** @jsx h */
import { h } from 'preact'
import Icon from './icons/icons'
import { Rifm } from 'rifm'
import clsx from 'clsx'
import dayjs from 'dayjs'
import { useGlobal } from '../use-global'

const parseDigits = string => (string.match(/\d+/g) || []).join('')

const formatDate = string => {
  const digits = parseDigits(string)
  const chars = digits.split('')
  return chars
    .reduce((r, v, index) => {
      if (dayjs().localeData().longDateFormat('L').startsWith('YYYY')) {
        return index === 4 || index === 6 ? `${r}/${v}` : `${r}${v}`
      } else {
        return index === 2 || index === 4 ? `${r}/${v}` : `${r}${v}`
      }
    }, '')
    .substr(0, 10)
}

const formatDateWithAppend = string => {
  const res = formatDate(string)

  if (dayjs().localeData().longDateFormat('L').startsWith('YYYY')) {
    if (string.endsWith('/')) {
      if (res.length === 4) {
        return `${res}/`
      }

      if (res.length === 7) {
        return `${res}/`
      }
    }
    return res
  } else {
    if (string.endsWith('/')) {
      if (res.length === 2) {
        return `${res}/`
      }

      if (res.length === 5) {
        return `${res}/`
      }
    }
    return res
  }
}

const appendHyphen = v => (v.length === 2 || v.length === 5 ? `${v}/` : v)

const Input = ({
  style = {},
  hasError,
  errorMessage,
  value = '',
  onChange,
  name,
  required,
  id,
  type = 'text',
  label,
  search,
  dateMask,
  className,
  maxLength,
  ariaLabel,
  placeholder
}) => {
  const [{ canvasConfig }] = useGlobal()
  return (
    <div className={clsx('rcc_c_input-component rcc-relative', className)} style={style}>
      {search ? <Icon name='search' className='rcc_c_input-icon' onClick={onChange} /> : ''}

      {label && (
        <label
          htmlFor={id}
          className={clsx('rcc-text-sm rcc-block rcc-mb-2.5', {
            'rcc-text-danger': hasError,
            'rcc-text-gray': !hasError,
            'rcc-text-right': canvasConfig.direction === 'rtl'
          })}
        >
          {label}
        </label>
      )}

      {dateMask ? (
        <Rifm
          accept={/\d+/g}
          mask={value.length >= 10}
          format={formatDateWithAppend}
          append={appendHyphen}
          value={value}
          onChange={onChange}
        >
          {({ value, onChange }) => (
            <input
              id={id}
              value={value}
              onChange={onChange}
              className={clsx(
                'rcc-w-full rcc-border-b rcc-placeholder-opacity-0 rcc-placeholder-gray-light rcc-text-sm',
                { 'rcc-border-danger rcc-text-danger': hasError },
                { 'rcc-border-gray-light rcc-text-text': !hasError }
              )}
              type={type}
              placeholder={placeholder}
              name={name}
              required={required}
            />
          )}
        </Rifm>
      ) : (
        <input
          id={id}
          value={value}
          onChange={onChange}
          className={clsx(
            'rcc-w-full rcc-border-b rcc-placeholder-opacity-0 rcc-placeholder-gray-light rcc-h-[24.8px]',
            {
              'rcc-border-danger rcc-text-danger': hasError,
              'rcc-border-gray-light rcc-text-text': !hasError,
              'rcc-text-right': canvasConfig.direction === 'rtl'
            }
          )}
          type={type}
          // placeholder={label}
          name={name}
          required={required}
          maxLength={maxLength}
          aria-label={ariaLabel}
        />
      )}
      {hasError && errorMessage && (
        <p
          className={clsx('rcc-mt-2 rcc-text-xs rcc-text-danger rcc-font-light', {
            'rcc-text-right': canvasConfig.direction === 'rtl'
          })}
        >
          {errorMessage}
        </p>
      )}
    </div>
  )
}

export default Input
